var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoM = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-1 -1 60 57",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.64 11.62h8.25l8.72 21.26h.37l8.72-21.26h8.25v31.65h-6.49v-20.6h-.26l-8.19 20.44h-4.42L18.4 22.59h-.26v20.67h-6.49V11.61z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#454BD1",
    d: "M14.1 49.97v4.92H0V40.77h4.92c.44 0 .8.31.89.72v7.59h7.58c.42.08.72.46.72.89z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D46944",
    d: "M43.46 4.92V0h14.11v14.12h-4.92c-.44 0-.8-.31-.89-.72V5.81h-7.58a.9.9 0 0 1-.72-.89"
  })));
};
export default SvgLogoM;